import React from 'react';
import Box from '@mui/material/Box';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { useTreeItem } from '@mui/x-tree-view/useTreeItem';
import {
  TreeItemContent,
  TreeItemIconContainer,
  TreeItemGroupTransition,
  TreeItemLabel,
  TreeItemRoot,
  TreeItemCheckbox,
} from '@mui/x-tree-view/TreeItem';
import { TreeItemIcon } from '@mui/x-tree-view/TreeItemIcon';
import { TreeItemProvider } from '@mui/x-tree-view/TreeItemProvider';
import { TreeItemDragAndDropOverlay } from '@mui/x-tree-view/TreeItemDragAndDropOverlay';
import logoPS from '../../assets/logo-ps-round.png';
import CloseIcon from '@mui/icons-material/Close';
import LabelIcon from '@mui/icons-material/Label';
import defAMPicture from '../../assets/pic-profile-sq.jpg';

function menuClose() {
  document.getElementById("sidemenu").style.display = "none";
}

function getAMList() {
  var am_json = JSON.parse(localStorage.getItem('cam'));
  if(am_json !== null && am_json.length > 0) {
    var amlist = [];
    var a=0;
    am_json.forEach((resList) => {
      a++;
      var amPicture = defAMPicture, amName = "", amPosition = "";
      if(resList.membercontent !== undefined) {
        if(resList.membercontent.userPicture !== undefined && resList.membercontent.userPicture !== '') {
          amPicture = resList.membercontent.userPicture;
        } 
        if(resList.membercontent.userFullname !== undefined && resList.membercontent.userFullname !== '') {
          amName = resList.membercontent.userFullname;
        } 
        if(resList.membercontent.userPosition !== undefined && resList.membercontent.userPosition !== '') {
          amPosition = resList.membercontent.userPosition;
        } 
        amlist.push(<div className="cs-profile" key={a}>
            <img src={amPicture} className="cs-profile-img" alt="csprofile"/>
            <div className="cs-detail">
                <span className="font-cs-name">{amName} </span><br/>
                <span className="font-cs-company-name">{amPosition}</span>
            </div>
        
       </div>)
      }
    })
    return amlist;
  }
}

const CustomTreeItem = React.forwardRef(function CustomTreeItem(props, ref) {
  const { id, itemId, label, disabled, children, ...other } = props;

  const {
    getContextProviderProps,
    getRootProps,
    getContentProps,
    getIconContainerProps,
    getCheckboxProps,
    getLabelProps,
    getGroupTransitionProps,
    getDragAndDropOverlayProps,
    status,
  } = useTreeItem({ id, itemId, children, label, disabled, rootRef: ref });

  return (
    <TreeItemProvider {...getContextProviderProps()}>
      <TreeItemRoot {...getRootProps(other)}>
        <TreeItemContent {...getContentProps()}>
          
          <Box sx={{ flexGrow: 1, display: 'flex', gap: 1 }}>
            <LabelIcon style={{color:'#777777'}} />
            <TreeItemCheckbox {...getCheckboxProps()} />
            <TreeItemLabel 
              sx={{
                fontSize: '0.9rem',
                fontWeight: 500,
                color: '#666666'
              }}
              {...getLabelProps()} 
            />
          </Box>
          <TreeItemIconContainer {...getIconContainerProps()}>
            <TreeItemIcon status={status} />
          </TreeItemIconContainer>
          <TreeItemDragAndDropOverlay {...getDragAndDropOverlayProps()} />
        </TreeItemContent>
        {children && <TreeItemGroupTransition {...getGroupTransitionProps()} />}
      </TreeItemRoot>
    </TreeItemProvider>
  );
});

function getItemUrl(url) {
  if(url.indexOf('#none$',0)<0) {
    document.location.href=global.cconfig.urlOrigin+"/"+url;
  }
  
}

function getParent(data, currpage) {
  if(currpage === "cnewsview") { currpage = "cnews"; }
  var resultPages = '';
  data.forEach((res) => {
    if(res.children !== undefined) {
      var isFound = res.children.filter((reschild) =>  {
        return (reschild.id === currpage || reschild.id.split('/')[0] === currpage);
      });
      if(isFound.length > 0) { resultPages = res.id; }
    }
  });
  return resultPages; 
}
function listMenu() {
  var dataMenu = [];
  dataMenu.push({ id: 'chome', label: 'Dashboard' });
  dataMenu.push({ id: '#none$1', label: 'Insights', children: [
      { id: 'cnews/1', label: 'News, Info & Updates' },
      { id: 'cnews/2', label: 'Promo'},
      { id: 'cnews/3', label: 'Events & Announcement'},
    ]
  });
  dataMenu.push({ id: '#none$2', label: 'Requests', children: [
      { id: 'caddlicence', label: 'Add Licence' },
      { id: 'crenewlicence', label: 'Renewal Licence'},
      // { id: 'cupgrade', label: 'Upgrade Licence'},
      { id: 'creqtraining', label: 'Training Session'},
    ] 
  });
  dataMenu.push({ id: '#none$3', label: 'Support', children: [
      { id: 'ccontact', label: 'Contact Us' },
    ] 
  });
   dataMenu.push({ id: 'cmyprofile', label: 'My Subscription' });
  return dataMenu;
}

export default function CSidemenu(props) {
  var geturl = window.location.pathname;
  var arrLink = geturl.split('/');
  var currpages = arrLink[1];
  
  var treeData = listMenu();
  var lv1pages = getParent(treeData, currpages);

  var ss_am_list = getAMList();
  const { showHideNav } = props;
  return (
    <div id="sidemenu" className="csidebar">
          <div className="company-profile">
            <a href="/"><img src={logoPS} className="company-logo" alt="logo"/></a>
            <div className="company-title">
              PointStar<br/>
              Customer Portal
            </div>
            <div className="csidebar-btn">
              { (showHideNav === true)? 
              <CloseIcon id="btCloseMenu" onClick={menuClose} ></CloseIcon>
              : ''
              }
            </div>
          </div>
          <div className="csidebar-content">
            <div>
              {ss_am_list}
            </div>
            <div className="font-main-menu">MAIN MENU</div>
            <div>
              {
                (lv1pages !== undefined)? 
                  <Box sx={{ minHeight: 200, minWidth: 250 }}>
                            <RichTreeView
                              defaultExpandedItems={[lv1pages]}
                              defaultSelectedItems={currpages}
                              items={treeData}
                              slots={{ item: CustomTreeItem }}
                              onItemClick={(event, item) => getItemUrl(item)}
                            />
                  </Box>
                : <></>
              }
            </div>
            
          </div>
          
    </div>

  );
}
